import { Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Button, Snackbar, Alert, Typography, useStepContext } from '@mui/material';
import Box from '@mui/material/Box';
import React, { useEffect, useRef, useState } from 'react'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import SendIcon from '@mui/icons-material/Send';
import {BarLoader, GridLoader, HashLoader, MoonLoader, PropagateLoader, PuffLoader, PulseLoader} from 'react-spinners'
import PrintIcon from '@mui/icons-material/Print';
import ModeEditOutlineIcon from '@mui/icons-material/ModeEditOutline';
import DeleteIcon from '@mui/icons-material/Delete';
import {useReactToPrint} from 'react-to-print'


function LotteryOut() {
    const [distributors,setDistributors] = useState([])
    const [DLBlotteries, setDLBLotteries] = useState([])
    const [NLBlotteries, setNLBLotteries] = useState([])
    const [submitLoading,setSubmitLoading] = useState(false)
    const [alertOpen,setAlertOpen] = useState(false)
    const [loading,setLoading] = useState(true)
    const [search,setSearch] = useState('')
    const [items, setItems] = useState([])
    const [Tickettotal, setTotal] = useState(0)
    const [isHovering, setIsHovering] = useState(false);
    const [totalTickets, setTotalTickets] = useState(0);
    const [inv_no,setInv_no] = useState('')
    const [pending,setPending] = useState(0)

    const [manageLotteries,setManageLotteries] = useState([])

    const currentTime = new Date();
    const hours = formatTwoDigits(currentTime.getHours());
    const minutes = formatTwoDigits(currentTime.getMinutes());
    const seconds = formatTwoDigits(currentTime.getSeconds());

    const getCurrentDate = () => {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
      const day = String(today.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
  };

  const getTomorrowDate = () => {
    const today = new Date();
    // Add one day to the current date
    today.setDate(today.getDate() + 1);
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};


  
    function formatTwoDigits(value) {
      return value < 10 ? `0${value}` : value;
    }


    useEffect(() => {

        var Total = 0.00
        var TotalTickets = 0

        //console.log("Manage lOtteris > ",manageLotteries)
        for (let i = 0; i < manageLotteries.length; i++) {
            ////console.log(parseFloat(items[i].total))
            if (manageLotteries[i].lineTotal){

              Total = Total + parseFloat(manageLotteries[i].lineTotal)
              TotalTickets = TotalTickets + parseInt(manageLotteries[i].qty)  
            }
        }
        
        //console.log(Total)
        setTotal(Total)
        setTotalTickets(TotalTickets)
    
      }, [manageLotteries])

    const styles = {
        mainContainer :{
          backgroundColor : '#F5F5F5',
          width:'100%',
          // display : 'flex',
          justifyContent : 'center',
          margin : 10,
        },
        RightContainer : {
          backgroundColor :'white',
          borderRadius: 5,
         
        },
    
        sidepnlBtn: {
          borderRadius: 10
          , display: 'flex'
          , flexDirection: 'column',
          alignItems: 'center'
        },
        BillBtn: {
          boxShadow: '1px 1px 10px #1e1e1e',
          backgroundColor: isHovering ? 'white' : 'white',
          height: 50,
          borderTopLeftRadius: 10,
          borderBottomLeftRadius: 10
    
        },
        PlusBtn: {
          boxShadow: '1px 1px 10px #1e1e1e',
          width: 35,
          borderRadius: 10
        },
        deleteBtn: {
          width: 25,
          marginLeft: 20,
    
        },
        billTable:{
          backgroundColor :'#f0f0f0',
          color : 'black',
          height : '60vh',
          padding : 10,
          borderRadius : 5,
          display : 'flex',
          flexDirection : 'column',
          borderTopLeftRadius : 0,
          justifyContent : 'space-between',
          overflow : 'auto',
          marginBottom : 10
        },
       
        paymentSelect: {
          width: '10wh',
          backgroundColor: 'white',
          padding: 10,
          boxShadow: '1px 1px 10px #1e1e1e',
          borderRadius: 5,
          marginTop: 20
    
        },
        style: {
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          border: '0px solid #000',
          boxShadow: 24,
          p: 4,
        }
    
        
    
      }


    const printsRef = useRef()

    const handlePrint = useReactToPrint({
      content: () => printsRef.current,
      pageStyle: `
      @page {
        width: 80mm; 
        height: 1000mm;
        margin-top: 0cm; 
        margin-right:5mm;
        margin-bottom: 0cm;
        margin-left: 0cm;
      }
      `,
    })

    const toPrint = async () => {
      setSubmitLoading(true); 
  
      // const { lotteryBoard, lottery, qty, unitPrice, total, drawDate } = formData;

      const header = {inv_no,distributorName,qty:totalTickets,Tickettotal,distId,draw_date:formData.drawDate}
      //console.log("header ",header)
      //console.log(items)

      try {
          
          const addResponse = await axios.post("https://servermunidasa.ccsoftwares.com/ticketOut/add", items);
          ////console.log(addResponse.data.message); 
  
          const updateResponse = await axios.put("https://servermunidasa.ccsoftwares.com/stock/updateRemaining", items);
          ////console.log(updateResponse.data.message); 

          const addHeaderResponse = await axios.post("https://servermunidasa.ccsoftwares.com/ticketOut/addHeader",header);
          ////console.log(addHeaderResponse.data.message); 
  
          setAlertOpen(true);
          handlePrint();
  
          // Reset form data
          setFormData({
              lotteryBoard: 'NLB',
              lottery: '',
              qty: '',
              unitPrice: '',
              total: '',
              drawDate: getTomorrowDate(),
              remainingStock : 0
          });

          setItems([]);
          setTotal(0);
          setTotalTickets(0)



      } catch (error) {
          alert(error.message || 'Server error / Insufficient Stock');
      } finally {
          setSubmitLoading(false); 
          fetchLastInvoiceNumber()
          refreshLotteryCounts()

      }
  };
  
  
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = formatTwoDigits(currentDate.getMonth() + 1); // Months are zero-based, so we add 1
    const day = formatTwoDigits(currentDate.getDate());
    const hour = formatTwoDigits(currentDate.getHours());
    const minute = formatTwoDigits(currentDate.getMinutes());
    const second = formatTwoDigits(currentDate.getSeconds());



    


    const [distributorName,setdistributorName] = useState('')
    const [distId,setDistId] = useState(0)

    useEffect( () => {

      const fetchLotteries = () =>{
        setLoading(true)
        axios.post('https://servermunidasa.ccsoftwares.com/lottery/groupbyentity',{"entity" : "DLB"}).then(ress => {
            //console.log(ress.data)
            setDLBLotteries(ress.data)
            axios.post('https://servermunidasa.ccsoftwares.com/lottery/groupbyentity',{"entity" : "NLB"}).then(res => {
              //console.log(res.data)
              setNLBLotteries(res.data)
              //console.log([...res.data,...ress.data ])
              setManageLotteries([...res.data,...ress.data])
              // setManageLotteries([...NLBlotteries, ...DLBlotteries])
              setLoading(false)
              
            }).catch((e) => {
              alert(e)
            }) 
          }).catch((e) => {
            alert(e)
          }) 
        }

         axios.get('https://servermunidasa.ccsoftwares.com/distributors/getAllDistributors').then(res => {
            // ////console.log(res.data)
            setDistributors(res.data)
        }).catch((e) => {
            alert(e)
        }) 
            async function fetchLastInvoiceNumber() {
              try {
                setLoading(true)
                  const response = await axios.get('https://servermunidasa.ccsoftwares.com/ticketOut/lastInvoice');
                  const data = await response;
                  const lastInvoiceNum = data.data.lastInvoiceNumber[0].lastInvoiceNumber
                  const nextInvoiceKey = lastInvoiceNum + 1;
        
                  // Generate the next invoice number in the format INVYYYY000001
                  const currentYear = new Date().getFullYear();
                  const newInvoiceNumber = `INV${currentYear}${nextInvoiceKey.toString().padStart(6, '0')}`;
              
                  ////console.log(newInvoiceNumber);
                  setInv_no(newInvoiceNumber)
                  setLoading(false)
                  // return data.data.lastInvoiceNumber[0].lastInvoiceNumber
        
              } catch (error) {
                  console.error('Error fetching the last invoice number:', error);
                  return null;
              }
          }

         fetchLastInvoiceNumber()
         fetchLotteries()

    }, [])




    const refreshLotteryCounts = () =>{
               axios.post('https://servermunidasa.ccsoftwares.com/lottery/groupbyentity',{"entity" : "DLB"}).then(res => {
            // ////console.log(res.data)
            setDLBLotteries(res.data)
        }).catch((e) => {
            alert(e)
        }) 

         axios.post('https://servermunidasa.ccsoftwares.com/lottery/groupbyentity',{"entity" : "NLB"}).then(res => {
            // ////console.log(res.data)
            setNLBLotteries(res.data)

        }).catch((e) => {
            alert(e)
        }) 
         axios.get('https://servermunidasa.ccsoftwares.com/distributors/getAllDistributors').then(res => {
            // ////console.log(res.data)
            setDistributors(res.data)
        }).catch((e) => {
            alert(e)
        }) 
    }


    async function fetchLastInvoiceNumber() {
      try {
        setLoading(true)
          const response = await axios.get('https://servermunidasa.ccsoftwares.com/ticketOut/lastInvoice');
          const data = await response;
          const lastInvoiceNum = data.data.lastInvoiceNumber[0].lastInvoiceNumber
          const nextInvoiceKey = lastInvoiceNum + 1;

          // Generate the next invoice number in the format INVYYYY000001
          const currentYear = new Date().getFullYear();
          const newInvoiceNumber = `INV${currentYear}${nextInvoiceKey.toString().padStart(6, '0')}`;
      
          ////console.log(newInvoiceNumber);
          setInv_no(newInvoiceNumber)
          setLoading(false)
          // return data.data.lastInvoiceNumber[0].lastInvoiceNumber

      } catch (error) {
          console.error('Error fetching the last invoice number:', error);
          return null;
      }
  }






    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setAlertOpen(false);
    };

    

    const [formData, setFormData] = useState({
        lotteryBoard: 'NLB',
        lottery: '',
        qty: '',
        unitPrice: '',
        total: '',
        drawDate : getTomorrowDate(),
        remainingStock : 0
      });


      const handleChange = (e) => {
        const { name, value } = e.target;
    
        if (name === 'qty') {
            // Prevent entering quantity greater than remainingStock
            const qty = parseInt(value, 10);
    
            if (qty > formData.remainingStock) {
                // Optionally, show a warning or feedback to the user if qty exceeds remaining stock
                alert(`You can't enter a quantity greater than ${formData.remainingStock}`);
                return;
            }
        }
    
        // If lottery is selected, update remainingStock based on the selected lottery
        if (name === 'lottery') {
            const selectedLottery = formData.lotteryBoard === 'DLB' 
                ? DLBlotteries.find(lottery => lottery.lotteryName === value)
                : NLBlotteries.find(lottery => lottery.lotteryName === value);
    
            setFormData((prevData) => ({
                ...prevData,
                [name]: value,
                remainingStock: selectedLottery ? selectedLottery.remainingStock : 0, // Update remainingStock
            }));
        } else {
            // Handle regular changes and update total if qty or unitPrice are changed
            setFormData((prevData) => ({
                ...prevData,
                [name]: value,
                total: name === 'qty' || name === 'unitPrice' 
                    ? calculateTotal({ ...prevData, [name]: value }) 
                    : prevData.total,
            }));
        }
    };

    const calculateTotal = (data) => {
        const qty = parseFloat(data.qty) || 0;
        const unitPrice = parseFloat(formData.unitPrice) || 0;
        return (qty * unitPrice).toFixed(2); 
    };

    


 

    const selectDistributor  = (e) => {

  
        const confirmAction = window.confirm("Are you sure to select this distributor?");
        if (confirmAction) {
          
                  setdistributorName(e.full_name)
                  setDistId(e.distKey)
          
                  const distKey = e.distKey
                  axios.post("https://servermunidasa.ccsoftwares.com/settle/getPendingDistributor",{distKey}).then(res =>{
                     setPending(res.data[0].pending || 0.00)
                   })
                }
   
        

 
    }



    const addTochart = () =>{
       const {drawDate,unitPrice} = formData


        // const { lotteryBoard, lottery, qty, unitPrice, total, drawDate, distributorName, distId, inv_no } = formData;

        const filteredItems = manageLotteries.filter(e => e.qty > 0);
      
        const newItems = filteredItems.map((e) => ({
          inv_no: inv_no,
          distributorName: distributorName,
          lotteryBoard: e.entity,
          lottery: e.lotteryName,
          qty: e.qty,
          unitPrice: unitPrice,
          drawDate: drawDate,
          total :  e.qty * unitPrice,  
          distId: distId,
        }));
      
        setItems(newItems);

        //console.log(newItems)



        ////console.log(newFormData)
        // setFormData({
        //     lotteryBoard: lotteryBoard,
        //     lottery: '',
        //     qty: '',
        //     unitPrice: unitPrice,
        //     total: '',
        //     drawDate: getTomorrowDate(),
        //     remainingStock : 0
        //   });


          // if (items.length > 0) {
          //   let found = false;
      
          //   items.forEach((item, i) => {
          //     if (newFormData.lottery === item.lottery) {
          //       found = true;
          //       alert("Already in the table. Please Check")
          //     }
          //   });
      
          //   if (!found) {
          //     const updateItem = [...items, newFormData];
          //     setItems(updateItem);
          //   }
          // } else {
          //   const updateItem = [...items, newFormData];
          //   setItems(updateItem);
          // }
      
        
    }

    const navigate = useNavigate();

    const validateForm = () => {
      const distributor = distributorName;
      const { lotteryBoard, lottery, qty, unitPrice, drawDate } = formData;
      if (!distributor || !drawDate || !unitPrice) {
          alert("Please fill out all required fields.");
          return false;
      }
      return true;
  };


  const goBack = () => {
    const confirmAction = window.confirm("Are you sure you want to go back?");
    if (confirmAction) {
      navigate(-1); 
    }
  };


  const handleQtyChange = (index, qty) => {
    setManageLotteries(prevLotteries => {
      const updatedLotteries = [...prevLotteries];
      const item = updatedLotteries[index];
  
      item.qty = qty;  // Update the qty value
      item.lineTotal = item.qty * (formData.unitPrice || 0);  // Calculate lineTotal if unitPrice exists
  
      return updatedLotteries;
    });
  };
  
  const handleUPriceChange = (index, uPrice) => {
    setManageLotteries(prevLotteries => {
      const updatedLotteries = [...prevLotteries];
      const item = updatedLotteries[index];
      item.lineTotal = (item.qty || 0) * formData.unitPrice;  // Calculate lineTotal if qty exists
  
      return updatedLotteries;
    });
  };
  

  return (
    <Grid container style={{padding: 20,backgroundColor : "white",fontFamily : 'Segoe UI',height : '100%',borderTopLeftRadius : 0, boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.25)'}}>
        {/* Topic section */}
        <Grid xs = {12} md = {12}>
            <div style={{display : 'flex',alignItems : 'center',justifyContent : 'left',height : 40}}>
            <button
            style={{
                    backgroundColor : 'white',
                    color: 'Black',
                    border: 'none',
                    cursor: 'pointer',
                    fontSize: 30,
                    marginTop : 10
                }}
                onClick={goBack}
            >
          <ArrowCircleLeftIcon fontSize='2'/>
        </button>
            <div style={{fontFamily : 'Segoe UI',fontSize : 28,fontWeight : '400'}}>
                Ticket Out
            </div>
        </div>

        </Grid>
        {/* Distributor Section */}
        <Grid xs = {12} md = {4} style={{backgroundColor : 'white'}}>
            <div style={{ padding: '20px', maxWidth: '100%',height : '100vh', margin: '0 auto' }}>
                <div style={{marginBottom : 10,marginTop : 10}}>
                <TextField id="outlined-basic" label="Search Distributors" variant="outlined" fullWidth onChange={(e) => {setSearch(e.target.value)}}/>
                </div>
                <div style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                {loading ? (<center><HashLoader size={30} color='Cyan'/></center>) : 
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        {distributors.filter((element) => {
                          if (search === '') {
                              return element
                          }
                          else if ((element.full_name.toLowerCase()).includes(search.toLowerCase()) ) {
                              return element
                              
                          }
                          
                      }).map((element, i) => (
                        <>
                            <tr>
                            <td colSpan={2}>
                                <hr style={{ border: 'none', borderTop: '0px solid black', margin: 0 }} />
                            </td>
                            </tr>
                            <tr
                            style={{
                                backgroundColor: 'white',
                                transition: 'background-color 0.3s ease',
                                height : 20
                            }}
                            onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#f0f0f0')}
                            onMouseOut={(e) => (e.currentTarget.style.backgroundColor = 'white')}
                           
                            >
                            <td style={{ textAlign: 'center', fontSize: 14,fontWeight : '600' }}>
                                <div style={{display : 'flex',justifyContent : 'space-between',alignItems : 'center'}}  onClick={() => selectDistributor(element)} >

                                <div style={{display : 'flex'}}>
                                <AccountCircleIcon style={{marginTop : 10}}/>
                                    <div style={{fontSize : 14,textAlign : 'left',margin : 10}}>

                                        Name : {element.full_name}<br></br>
                                        Registration : {element.Distri_ID}<br></br>
                                        Contact No : {element.Phone_Number}<br></br>
                                    
                                    </div>
                                </div>
                                <div>
                                <ArrowForwardIosIcon />
                                </div>
                            </div>

                                </td>
                            </tr>

                            <tr>
                            <td colSpan={2}>
                                <hr style={{ border: 'none', borderTop: '1px solid white', margin: 0 }} />
                            </td>
                            </tr>
                        </>
                        ))}
                    </table>}
                    </div>
            </div>
        </Grid>
        {/* Ticket Selection section */}
        <Grid xs = {12} md = {5}>
        <Paper elevation={0} style={{ padding: '20px', maxWidth: '100%',height : '100vh' }}>
        <Typography variant="h5" gutterBottom>
            Distribute Lotteries {distributorName != '' ? (<>for {distributorName}</>) : <></>}
        </Typography>
        <form onSubmit={(e) => { 
              e.preventDefault(); // Prevent default form submission behavior

              if (validateForm()) {
                addTochart(); // Call the function only if the form is valid
              }
          }}>
            <Grid container spacing={2}>
            <Grid item xs={4}>
                <TextField
                label="Distributor Name"
                name="distributor"
                fullWidth
                value={distributorName}
                onChange={handleChange}
                required
                disabled
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <TextField
                    label="Draw date"
                    name="drawDate"
                    type="date"
                    fullWidth
                    value={formData.drawDate}
                    onChange={handleChange}
                    InputLabelProps={{
                        shrink: true, 
                    }}
                    required
                />
            </Grid>

            <Grid item xs={12} sm={4}>
            <TextField
                label="Unit price"
                name="unitPrice"
                fullWidth
                value={formData.unitPrice}
                onChange={handleChange}
                required
                />
            </Grid>

            {/* {formData.lotteryBoard === 'DLB' ? (
                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="Lottery"
                                name="lottery"
                                select
                                fullWidth
                                value={formData.lottery}  
                                onChange={handleChange}
                                required
                            >
                                {DLBlotteries.map((e,i) => (
                                        <MenuItem key={i} value={e.lotteryName}>{e.lotteryName } : {e.remainingStock}</MenuItem>
                                        ))}
                            </TextField>
                        </Grid>
                ):<>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="Lottery"
                                name="lottery"
                                select
                                fullWidth
                                value={formData.lottery}  
                                onChange={handleChange}
                                required
                            >
                                {NLBlotteries.map((e,i) => (
                                        <MenuItem key={i} value={e.lotteryName}>{e.lotteryName} : {e.remainingStock}</MenuItem>
                                        ))}
                            </TextField>
                        </Grid>
                
                </>} */}

                <Grid item xs={12} sm={12}>

                <TableContainer style={{ maxHeight: '350px', overflowY: 'auto'}}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell style={{fontWeight : '600'}}>Lottery</TableCell>
                      <TableCell style={{fontWeight : '600'}}>Available</TableCell>
                      {/* <TableCell style={{fontWeight : '600',textAlign : 'center'}}>Unit P.</TableCell> */}
                      <TableCell style={{fontWeight : '600',textAlign : 'center'}}>Out</TableCell>
                      <TableCell style={{textAlign : 'center',fontWeight : '600'}}>Total</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {loading ? (
                      <center><HashLoader size={30} color='black' style={{ marginLeft: 20 }} /></center>
                    ) : (
                      manageLotteries.map((item, index) => (
                        <TableRow key={index}>
                        <TableCell>{item.lotteryName}</TableCell>
                        <TableCell style={{ textAlign: 'center' }}>{item.remainingStock}</TableCell>
                        {/* <TableCell>
                          <TextField
                            type="number"
                            value={item.unitPrice || ''}
                            onChange={(e) => handleUPriceChange(index, parseFloat(e.target.value))}
                            style={{ width: '80px' }}
                            InputProps={{
                              style: { fontSize: 12 },
                            }}
                          />
                        </TableCell> */}
                        <TableCell style={{ textAlign: 'center' }}>
                          <TextField
                            type="number"
                            value={item.qty || ''}
                            onChange={(e) => handleQtyChange(index, parseInt(e.target.value))}
                            style={{ width: '70px' }}
                            InputProps={{
                              style: { fontSize: 11 },
                              inputProps: { style: { MozAppearance: 'textfield' } },
                            }}
                          />
                        </TableCell>
                        <TableCell>{(item.lineTotal || 0).toFixed(2)}</TableCell>
                      </TableRow>
                      )))}
                    
                  </TableBody>
                </Table>
              </TableContainer>

{/*               
                <TextField
                                label="Lottery"
                                name="lottery"
                                select
                                fullWidth
                                value={formData.lottery}  
                                onChange={handleChange}
                                required
                            >
                                {DLBlotteries.map((e,i) => (
                                        <MenuItem key={i} value={e.lotteryName}>{e.lotteryName } : {e.remainingStock}</MenuItem>
                                        ))}

                                {NLBlotteries.map((e,i) => (
                                        <MenuItem key={i+50} value={e.lotteryName}>{e.lotteryName} : {e.remainingStock}</MenuItem>
                                        ))}
                 </TextField> */}

                </Grid>
{/* 
                <Grid item xs={12} sm={6}>
                <TextField
                    label="Qty"
                    name="qty"
                    type="number"
                    fullWidth
                    value={formData.qty}
                    onChange={handleChange}
                    required
                    inputProps={{
                        max: formData.remainingStock, // Set the max to remainingStock
                    }}
                    helperText={`Stock for selected lottery: ${formData.remainingStock}`}
                />
            </Grid> */}
            {/* <Grid item xs={12} sm={6}>
                <TextField
                label="Unit Price"
                name="unitPrice"
                type="number"
                fullWidth
                value={formData.unitPrice}
                onChange={handleChange}
                required
                />
            </Grid> */}
       
{/* Total */}
            {/* <Grid item xs={12}>
            <TextField
                label="Total"
                name="total"
                fullWidth
                value={formData.total}
                InputProps={{
                style: {
                    color: 'black', 
                    backgroundColor: 'transparent', 
                },
                }}
                InputLabelProps={{
                style: {
                    color: 'black', 
                },
                }}
            />
            </Grid> */}

            <Grid item xs={6} sm={3} justifyContent="flex-end" style={{marginLeft : '80%'}}>
            {submitLoading ? (<><PulseLoader size = {14} color='#00ffdd' speedMultiplier={1}/></>) : 
                 <Button variant="outlined" color="primary" onClick={() => {
                  if (validateForm()) {
                    addTochart();
                  }
              }} fullWidth endIcon={<SendIcon />}>
                  Add 
              </Button>
                }
            </Grid>
            </Grid>
        </form>
    </Paper>
        </Grid>

        <Snackbar open={alertOpen} autoHideDuration={6000} onClose={handleClose}>
                <Alert onClose={handleClose} severity='success' sx={{ width: '100%' }}>
                    Ticket Stock Updated
                </Alert>
        </Snackbar>
        {/* Lottary chart */}
        <Grid item xs = {12} md  = {3}>
        <div style={{height :'100%',margin:10}}>
        <Box xs ={2} width={'100%'}>
            {/* Lottary */}
            <div style={styles.billTable}>
              <table width={'100%'} border={0}>
                <tr style={{backgroundColor : '#f0f0f0',fontSize:15}} >
                  <th align='left' ></th>
                  <th align='left' width={200}>Lottery</th>
                  <th align='center'>Each</th>
                  <th align='right'>Qty</th>
                  <th align='right'></th>
                  <th align='right'></th>
                </tr>
              
                {items.slice().reverse().map((e,i) =>(
                  <>
                  <tr style={{fontSize:18,fontFamily : 'consolas'}}>
                    <td align='left'>{i+1}).</td>
                    <td align='left' width={200} colSpan={4}>{e.lottery}</td>
                  </tr>
                  <tr>
                    <td align='left' colSpan={2}>{}</td>
                    <td align='left' >{e.unitPrice}</td>
                    <td align='center' style={{fontWeight : 'bold'}}>{e.qty}</td>
                    <td align='right' >
            
                    </td>
                    {/* <td>
                    <img src ={require('../Assests/delete.png')} alt = 'delete' style={styles.deleteBtn} width={20} onClick={() => {setItems(items.filter(item => item.lottery !== e.lottery));}}></img>
                    </td> */}

                  </tr>
                  </>
                ))}
              </table> 
            </div>
           <div >
          {Tickettotal >0 ? <>
          <div style={{fontWeight : '600'}}>
          Total Ticket Count : {totalTickets} <br></br>
          Total : Rs. {parseFloat(Tickettotal).toFixed(2)}
          </div>
          
            
              {submitLoading ? <>
                <PulseLoader size = {14} color='#00ffdd' speedMultiplier={1}/>
              </> : <>
                <Button variant="outlined" color="primary"  endIcon={<PrintIcon />} fullWidth onClick={ () => {toPrint()}}>
                Print 
                </Button>
              </>}
                </>:<>
                <Button variant="outlined" color="primary"  endIcon={<PrintIcon />} fullWidth>
                Print 
                </Button>
                
                
                </>}
        </div>
      </Box>
                </div>
        </Grid>
        {/* <Grid md = {12}> */}
        <div style={{display : 'none',position : 'relative',zIndex:1000,justifyContent : 'center',top : 0,jeft :0,width : '100%',height : '100%',alignItems : 'center'}}>
        {/* <div style={{position : 'relative',zIndex:1000,justifyContent : 'center',top : 0,jeft :0,width : '100%',height : '100%',alignItems : 'center'}}> */}
        <table border={0} width={'300'} style={{ fontFamily: 'Consolas',backgroundColor : 'white',fontWeight : '800', height : 8 }} id='BillingDoc'  ref={printsRef} >
                   <tr>
                <td colSpan={4} align='center' style={{ fontSize: 14, fontWeight: 'bold' }}><label style={{ fontSize: 18 }}>M.M.Munidasa Lottery Agency<br></br></label>175/23/E, Mahawatta Road, 
                Pelanwatta,<br></br>Pannipitiya<br></br>Tel. (+94) 788 393 515</td>
            </tr>
            <tr>
              <td colSpan={4}><hr></hr></td>
            </tr>
            <tr>
              <td colSpan={4}>Distributor : {distributorName}</td>
            </tr>
            <tr>
              <td colSpan={4}>Invoice No : {inv_no}</td>
            </tr>
            <tr colSpan={4} align='center'>
                <td colSpan={5} align='left'>Draw Date : {formData.drawDate}</td>
            </tr>
            <tr colSpan={4} align='center'>
                <td colSpan={4} align='left'>Date : {`${year}-${month}-${day} | Time: ${hours}:${minutes}`}</td>
            </tr>
            {items?.map((e, i) => (
                <>
                <tr>
                    <td align='right'>{i + 1}<>).</></td>
                    <td colSpan={3}>{e.lottery} </td>
                </tr>
                <tr style={{ backgroundColor: 'white' }}>
                    <td ></td>
                    <td align='right' style={{height : 10}}>{e.qty}</td>
                    <td align='center' colSpan={1}>{parseFloat(e.unitPrice).toFixed(2)}</td>
                    <td align='right'>{e.total}</td>
                </tr>
                </>
                ))}
                <td colSpan={4} align='right'>-------------------------------- </td>
                <tr>
                <td align='right' colSpan={2}>T.T.:{totalTickets}</td>
                <td  align='right' colSpan={2} style={{width : 200}}>Total :   Rs.{parseFloat(Tickettotal).toFixed(2)}</td>
                </tr>
                <tr>
                </tr>
               
                <tr>
                <td colSpan={4} align='center'  
                 style={{ 
                    fontWeight: 'bold', 
                    border: '2px solid black', // Add black border
                    color: 'black', 
                    backgroundColor: 'transparent', // Set background to transparent
                  }}>Pending Rs.{(parseFloat(Tickettotal)+parseFloat(pending)).toFixed(2)}
                </td>
                </tr>
            
                <tr>
                <td colSpan={4} align='center' style={{fontSize : 10}}></td>
                </tr>
                <tr>
                <td colSpan={4} align='center' style={{fontSize : 15}}>Provide this when settling the payment!</td>
                </tr>
                <tr>
                <td colSpan={4} align='center'>--------------------------------</td>
                </tr>
                <tr>
                <td colSpan={4} align='center' style={{fontSize : 13,fontWeight:'bold',height : 10}}>Software by CC Software Solutions</td>
                </tr>
                <tr>
                <td colSpan={4} align='center' style={{fontSize : 13,fontWeight:'bold'}}>077 0832 340</td>
                </tr>
            </table>
        </div>
    </Grid>
  )
}

export default LotteryOut